import { Children } from "react";
import styles from "./card.module.css";

export default function Card({
  children,
  id,
  className = "",
  borders = "all",
}) {
  const classes = [className, styles.container, styles["borders-" + borders]].filter(x => x !== '').join(' ');
  return (
    <div
      id={id}
      className={classes}
    >
      {Children.map(children, (child) => child)}
    </div>
  );
}
